import { BackgroundColors, BorderRadius } from "@abel-technologies-as/components";
import styled from "styled-components";

const StyledCompanyTable = styled.div`
	margin-top: 5px;
	width: 100%;
`;

const CollapseContainer = styled.div`
	padding: 10px;
	background-color: ${BackgroundColors.PrimaryAlt};
	border-radius: ${BorderRadius.SM}px;
	margin-bottom: 10px;
`;

export { StyledCompanyTable, CollapseContainer };
